import { Controller } from 'stimulus';
import { debounce } from 'lodash-es';

// Connects to data-controller="users-search"
export default class extends Controller {
  static targets = ['input', 'results', 'result'];

  connect() {
    const handleInput = debounce(() => {
      this.clearUserId();
      this.search();
    }, 800);

    this.inputTarget.addEventListener('keyup', handleInput);
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  clearUserId() {
    if (this.inputTarget.value.trim() === "") {
      const idField = document.querySelector('[name="card[user_id]"]');
      if (idField) idField.value = "";
    }
  }

  search() {
    const query = this.inputTarget.value;

    if (query.length < 3) {
      this.hideResults();
      return;
    }

    const siteSelect = document.querySelector('[name="card[site_id]"]');
    const siteId = siteSelect ? siteSelect.value : null;

    let url = `/customers/users/search?query=${encodeURIComponent(query)}`;

    if (siteId) {
      url += `&site_id=${encodeURIComponent(siteId)}`;
    }

    fetch(url, {
      method: 'GET',
      headers: { Accept: 'text/vnd.turbo-stream.html' },
    })
      .then((response) => response.text())
      .then((html) => (this.resultsTarget.innerHTML = html));
  }

  selectResult(event) {
    const userEmail = event.currentTarget.dataset.userEmail;
    const userFullName = event.currentTarget.dataset.userFullNameId;
    const userId = event.currentTarget.dataset.userId;

    const cardUserIdField = document.querySelector('[name="card[user_id]"]');

    if (cardUserIdField) {
      cardUserIdField.value = userId;
      this.inputTarget.value = userFullName;
    } else {
      this.inputTarget.value = userEmail;
    }


    this.hideResults();
  }

  handleClickOutside(event) {
    const withinComponent = this.element.contains(event.target);
    if (!withinComponent) {
      this.hideResults();
    }
  }

  hideResults() {
    this.resultsTarget.innerHTML = '';
  }
}
